"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Button_1 = __importDefault(require("../Button"));
var trophies_1 = __importDefault(require("./trophies"));
var GoldIcon_1 = __importDefault(require("./GoldIcon"));
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        imageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        image: {
            width: 120,
            imageRendering: 'pixelated',
        },
        name: {
            fontSize: '12px',
        },
    });
});
var PurchaseTrophiesDialog = function (_a) {
    var availableGold = _a.availableGold, trophyId = _a.trophy, onClickClose = _a.onClickClose, onClickBuy = _a.onClickBuy, hasPurchased = _a.hasPurchased, other = __rest(_a, ["availableGold", "trophy", "onClickClose", "onClickBuy", "hasPurchased"]);
    var classes = exports.useStyles();
    var trophy = trophies_1.default.find(function (_a) {
        var id = _a.id;
        return id === trophyId;
    });
    return (react_1.default.createElement(core_1.Dialog, __assign({ fullWidth: true, maxWidth: "sm" }, other),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, className: classes.imageContainer },
                    react_1.default.createElement("img", { alt: trophy.name, className: classes.image, src: "/images/trophies/" + trophy.id + ".png" })),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8 },
                    react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h3" }, trophy.name),
                    react_1.default.createElement(core_1.Typography, { paragraph: true }, trophy.description)))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: onClickClose }, "Close"),
            !hasPurchased && (react_1.default.createElement(Button_1.default, { variant: "flat", color: "primary", disabled: availableGold < 18, onClick: onClickBuy },
                "Buy for: 18",
                react_1.default.createElement(GoldIcon_1.default, { active: availableGold >= 18, style: { width: 14, marginLeft: 3 } }))))));
};
exports.default = PurchaseTrophiesDialog;
//# sourceMappingURL=PurchaseTrophyDialog.js.map